const formatRegex = /^.+\.([a-zA-Z0-9]+)(\?|$)/;
const getExtension = (file: string): string | undefined => {
  const matches = file.match(formatRegex);

  return matches && matches.length ? matches[1] : undefined;
};

export default getExtension;
